export const AUTHORIZATION_KEY = "app_access_token";

export const displayDateTimeFormat = 'DD/MM/YYYY HH:mm';
export const displayNoYearDateTimeFormat = 'DD/MM HH:mm';
export const displayDateFormat = 'DD/MM/YYYY';
export const chatDisplayDateTimeFormat = 'DD/MM HH:mm';
export const backendDisplayDateTimeFormat = "YYYY-MM-DD HH:mm:ss";
export const backendDisplayDateFormat = "YYYY-MM-DD";

// adjust this for croatian number format 
export const phoneNumberMaskFormat = "(111) 111-1111"
export const phoneNumberMaskFormatNines = "(999) 999-9999"

export const defaultPagination = {
  current: 1,
  pageSize: 10,
}